import { CachedSprites, fetchImage } from 'lib/utils';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const useImageLoad = (loadActionCreator: any, saveActionCreator: any) => {
  const dispatch = useDispatch();
  const [spritesList, setSpritesList] = useState<CachedSprites>([]);

  const loadSetting = useCallback(async () => {
    const action: any = await dispatch(loadActionCreator());
    if (action.error) {
      return;
    }
    const loadPERSONS = await Promise.allSettled(
      action.payload.map((p: any) => fetchImage(p.id, p.img))
    );
    let load = true;

    const savePerson = loadPERSONS.reduce((a, b) => {
      if (b.status !== 'fulfilled') {
        load = false;
      } else {
        return { ...a, ...(b.value || {}) };
      }
      return a;
    }, {});
    dispatch(saveActionCreator(load));
    if (load) {
      setSpritesList(savePerson as any);
    }
  }, [dispatch]);

  useEffect(() => {
    loadSetting();
  }, [loadSetting]);

  return spritesList;
};

export default useImageLoad;
